import { useSetModal } from "@/shared/atoms/useModal";
import usePosOrderCurrentAction, {
  CurrentActionTypes,
} from "@/shared/atoms/usePosOrderCurrentAction";
import { useAddCartItem } from "@/shared/hooks/useCartHook";
import useVatHook from "@/shared/hooks/useVatHook";
import { getRandomNegativeId } from "@/shared/utils/helpers";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const useDefaultAction = () => {
  const { t } = useTranslation();
  const [currentAction, setCurrentAction] = usePosOrderCurrentAction();
  const setModal = useSetModal();
  const addCartItem = useAddCartItem();
  const { vats } = useVatHook();

  useEffect(() => {
    currentAction?.name === undefined && setDefaultAction();
  }, [currentAction?.name]);

  const setDefaultAction = () => {
    setCurrentAction({
      name: "customProduct" as CurrentActionTypes,
      action: (newPrice: any) => {
        const cartItem = {
          price: newPrice,
          description: "",
          vat_percentage: vats[1].percentage,
          name: t("posOrders.openProduct"),
          item_id: getRandomNegativeId(),
          quantity: 1,
        };
        if (currentAction?.name === "customProduct" && newPrice === undefined) {
          setModal("posOrderProduct", {
            product: cartItem,
          });
        } else if (newPrice) {
          addCartItem(cartItem);
        }
      },
    });
  };
  return setDefaultAction;
};
export default useDefaultAction;
